<h1 class="mine-title-l maintenance__title" [innerHTML]="'maintenance.dsrHeader' | content"></h1>

<p class="maintenance__text">{{ 'maintenance.dsrText' | content }}</p>

<img ngSrc="{{assetsUrl}}/Portal/sima-in-a-rocket.png" width="380" height="285" class="maintenance__img">